import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

const windIcon: IconManifest = {
    id: 'wind-icon',
    width: 128,
    height: 128,
    d: 'M68.436 16.226a17.144 17.144 0 1 1 2.5 34.06H30.78a5.32 5.32 0 0 1 0-10.64h40.303a6.503 6.503 0 1 0-6.087-8.428 5.32 5.32 0 1 1-10.164-3.151 17.144 17.144 0 0 1 13.604-11.841ZM98.17 70.11a6.504 6.504 0 0 0-3.439-.907l-.102.001H21.32a5.32 5.32 0 0 1 0-10.64h73.263a17.144 17.144 0 1 1-16.103 22.22 5.32 5.32 0 0 1 10.164-3.152 6.503 6.503 0 1 0 9.526-7.522ZM55.603 89.029a6.503 6.503 0 0 0-3.438-.906H26.05a5.32 5.32 0 0 1 0-10.64h25.967a17.145 17.145 0 1 1-16.103 22.22 5.32 5.32 0 0 1 10.163-3.152 6.504 6.504 0 1 0 9.526-7.522Z',
};

export function WindIcon(props: IconBaseProps) {
    const { id, d } = windIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="WindIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
